import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  ButtonGroup,
  Button,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import removalsActions from "../../../../redux/actions/removalsGreenPoint";

import { ArrowForwardIos, ArrowBackIos, Check } from "@material-ui/icons";
import convertUTCDateToLocalDate from "../../../../helpers/utcToLocalDate";

import Header from "../../../Shared/Modals/Header";
import Materials from "./Materials";
import General from "./General";

const initialState = {
  materials: null,
  description: "",
  datetimeRemoval: convertUTCDateToLocalDate(new Date()),
};

export default function CreateModal() {
  const dispatch = useDispatch();
  const removals = useSelector((state) => state.removalsGreenPoint);
  const app = useSelector((state) => state.app);
  const { goalProgress } = useSelector((state) => state.indicators);
  const utils = useSelector((state) => state.utils);

  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (error) {
      setTimeout(() => setError(false), 1500);
    }
  }, [error]);

  useEffect(() => {
    if (utils.materials && removals.createModal) {
      let materials = {};
      Object.keys(utils.materials).forEach((material) => {
        materials[material] = 0;
      });
      setFormData({ ...formData, materials });
    }
  }, [utils.materials, removals.createModal]);

  const handleClose = () => {
    dispatch(removalsActions.setCreateModal(false));
    setStep(1);
    setFormData(initialState);
  };

  const handleProgress = async (action) => {
    if (action === "NEXT") {
      if (step === 1) {
        let sum = await Object.keys(formData.materials).reduce(
          (total, current) => (total += formData.materials[current] * 1),
          0
        );
        if (sum) {
          setStep(2);
        } else {
          setError(true);
        }
      }
      if (step === 2) {
        const currentFormData = formData;
        const materials = Object.keys(formData.materials).map((material) => {
          return {
            material,
            quantity: formData.materials[material],
          };
        });
        currentFormData.materials = materials;
        currentFormData.datetimeRemoval = convertUTCDateToLocalDate(new Date());

        dispatch(removalsActions.postRemoval({ formData: currentFormData }));

        handleClose();
      }
    }
    if (action === "PREVIUS" && step > 1) {
      setStep(step - 1);
    }
  };

  const titles = () => {
    if (step === 1) {
      return "Ingresar nuevo registro - Materiales";
    }
    if (step === 2) {
      return "Ingresar nuevo registro - Descripción";
    }
  };

  return (
    <Dialog
      open={removals.createModal}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      scroll={"body"}
      fullScreen={app.isMobile}
    >
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Header handleClose={handleClose} title={titles()} type="CREATE" />
          </Grid>
          {step === 1 && (
            <Grid item xs={12}>
              <Materials
                formData={formData}
                setFormData={setFormData}
                error={error}
              />
            </Grid>
          )}
          {step === 2 && (
            <Grid item xs={12}>
              <General formData={formData} setFormData={setFormData} />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonGroup size="small" variant="contained">
          <Button
            color="primary"
            startIcon={<ArrowBackIos />}
            disabled={step === 1}
            onClick={() => handleProgress("PREVIUS")}
          >
            atrás
          </Button>
          <Button
            color="primary"
            endIcon={step === 2 ? <Check /> : <ArrowForwardIos />}
            onClick={() => handleProgress("NEXT")}
          >
            {step === 2 ? "registar" : "siguiente"}
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
}
